import React from 'react'
import logo from './img/LLNR_logo.png'

const Navbar = () => (
  <nav className="navbar navbar-default navbar-static-top navbar-lln">
    <div className="container-fluid">
      <div className="navbar-header">
        <a href="/">
          <img src={logo} alt="LLN Robot System" height="80px" />
        </a>
      </div>
      <div
        className="collapse navbar-collapse"
        id="bs-example-navbar-collapse-1">
        <ul className="nav navbar-nav navbar-right hidden-md hidden-sm hidden-xs">
          <li>A Complete LLN Solution for your RTO</li>
        </ul>
      </div>
    </div>
  </nav>
)

export default Navbar



// WEBPACK FOOTER //
// ./src/Navbar.js